/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClaimTransaction } from './ClaimTransaction';
import {
    ClaimTransactionFromJSON,
    ClaimTransactionFromJSONTyped,
    ClaimTransactionToJSON,
    ClaimTransactionToJSONTyped,
} from './ClaimTransaction';

/**
 * List of transactions for a claim
 * @export
 * @interface TransactionListResponse
 */
export interface TransactionListResponse {
    /**
     * 
     * @type {Array<ClaimTransaction>}
     * @memberof TransactionListResponse
     */
    items: Array<ClaimTransaction>;
}

/**
 * Check if a given object implements the TransactionListResponse interface.
 */
export function instanceOfTransactionListResponse(value: object): value is TransactionListResponse {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function TransactionListResponseFromJSON(json: any): TransactionListResponse {
    return TransactionListResponseFromJSONTyped(json, false);
}

export function TransactionListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransactionListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(ClaimTransactionFromJSON)),
    };
}

export function TransactionListResponseToJSON(json: any): TransactionListResponse {
    return TransactionListResponseToJSONTyped(json, false);
}

export function TransactionListResponseToJSONTyped(value?: TransactionListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(ClaimTransactionToJSON)),
    };
}

